import Dexie from "dexie"
import React, {Component} from "react";
import {getGUID, TYPES_CACHE_TTL_MS} from "../../assets/constants";

// Время жизни кэша синхронизации (используем общую константу 30 минут)
const SYNC_CACHE_TTL_MS = TYPES_CACHE_TTL_MS;
// TTL для стендов и коллекций - 12 часов
const BRANDS_SYNC_TTL_MS = 12 * 60 * 60 * 1000;

class EntitySync extends Component {
    
    constructor(props, entityName, fields) {
        super(props);

        if (new.target === EntitySync) {
            throw new TypeError("Невозможно создать экземпляр абстрактного класса EntitySync.")
        }

        if(props && props.autoUpload) {
            const uploadFieleds = ['uploaded', 'createdAt', 'uploadedAt']


            for (let uField of uploadFieleds) {
                if (fields.indexOf(uField) == -1) {
                    fields.push(uField)
                }
            }
            if (fields.indexOf('guid') == -1) {
                fields.unshift('guid')
            }

        }


        this.fields = fields
        this.entityName = entityName
        this.lastSyncKey = `${entityName}_last_sync`


        this.db = new Dexie(this.entityName)
        this.db.version(1).stores({
            [this.entityName]: `${this.fields.join(',')}`
        })
        if(props && props.autoSync) {
            this.startSync()
        }
        if(props && props.autoUpload) {
            this.startUploadQueue()
        }
    }

    /**
     * Проверяет, истёк ли кэш синхронизации
     * @returns {boolean} true если кэш истёк или отсутствует
     */
    isSyncCacheExpired = () => {
        const lastSync = localStorage.getItem(this.lastSyncKey);
        if (!lastSync) return true;
        
        // Используем кастомный TTL если передан через пропсы, иначе дефолтный
        const ttl = this.props?.syncTTL || SYNC_CACHE_TTL_MS;
        
        const elapsed = Date.now() - parseInt(lastSync, 10);
        return elapsed > ttl;
    }

    /**
     * Сохраняет timestamp последней синхронизации
     */
    updateLastSyncTime = () => {
        localStorage.setItem(this.lastSyncKey, Date.now().toString());
    }

    /**
     * Одноразовый перенос данных из старой базы Dexie (до переименования бренд -> стенд).
     * Открывает старую базу без схемы, копирует строки в this.db, удаляет старую базу
     * и переносит отметку последней синхронизации.
     */
    async migrateLegacyDb(oldDbName, oldStoreName, mapRow = (row) => row) {
        try {
            if (!(await Dexie.exists(oldDbName))) return

            const oldDb = new Dexie(oldDbName)
            await oldDb.open()
            const hasStore = oldDb.tables.some(t => t.name === oldStoreName)
            const rows = hasStore ? await oldDb.table(oldStoreName).toArray() : []
            oldDb.close()

            if (rows.length > 0) {
                await this.db[this.entityName].bulkPut(rows.map(mapRow))
            }
            await Dexie.delete(oldDbName)

            const legacyKey = `${oldDbName}_last_sync`
            const legacyLastSync = localStorage.getItem(legacyKey)
            if (legacyLastSync && !localStorage.getItem(this.lastSyncKey)) {
                localStorage.setItem(this.lastSyncKey, legacyLastSync)
            }
            localStorage.removeItem(legacyKey)
            console.log(`${this.entityName}: перенесено из ${oldDbName}: ${rows.length}`)
        } catch (e) {
            console.error(`${this.entityName}: ошибка переноса из ${oldDbName}`, e)
        }
    }

    render() {
        return ''
    }
    async fetchData() {

    }
    receiveMessage = (event) => {
        if(event.data.type == 'isLogined' && event.data.value){
            if(this.props && this.props.autoSync) {
                // Проверяем требуется ли адресная программа для синхронизации
                if(this.props.requiresAddressProgram) {
                    const user = event.data.user;
                    if(user && user.address_program == '1') {
                        this.syncDataIfNeeded();
                    } else {
                        console.log(`⏭️ ${this.entityName}: пропуск синхронизации (требуется АП, но у пользователя нет доступа)`);
                    }
                } else {
                    // Если не требуется АП, синхронизируем как обычно
                    this.syncDataIfNeeded();
                }
            }
        }
        
        // Обработка принудительной синхронизации для offline
        if(event.data == 'forceOfflineSync') {
            if(this.props && this.props.autoSync) {
                console.log(`🔄 ${this.entityName}: принудительная синхронизация для offline`);
                this.syncDataIfNeeded(true).then(() => {
                    // Уведомляем о завершении синхронизации
                    window.postMessage('offlineSyncComplete');
                });
            }
        }
    }
    componentDidMount() {
        window.addEventListener('message', this.receiveMessage, false)

    }

    componentWillUnmount() {
        window.removeEventListener('message', this.receiveMessage, false)
        if(this.uploadInterval){
            clearInterval(this.uploadInterval)
        }
        if(this.syncInterval){
            clearInterval(this.syncInterval)
        }
    }

    startUploadQueue() {
        if(this.uploadInterval){
            clearInterval(this.uploadInterval)
        }
        this.uploadInterval = setInterval(async () => {
            await this.uploadPendingEntities();
            await this.cleanupOldEntities();
        }, 5000);

    }
    startSync() {
        if(this.syncInterval){
            clearInterval(this.syncInterval)
        }
        
        // Запускаем синхронизацию только если кэш истёк
        this.syncDataIfNeeded().then(() => {
            // Интервал проверки каждые 15 минут (синхронизация произойдёт только если TTL истёк)
            this.syncInterval = setInterval(() => {
                this.syncDataIfNeeded()
            }, 15 * 60 * 1000)
        })
    }

    /**
     * Синхронизирует данные только если прошло более 30 минут с последней синхронизации
     * @param {boolean} force - Принудительная синхронизация, игнорируя кэш
     */
    async syncDataIfNeeded(force = false) {
        if (!force && !this.isSyncCacheExpired()) {
            console.log(`⏳ ${this.entityName}: кэш актуален, пропускаем синхронизацию`);
            return;
        }
        
        await this.syncData();
    }
    async cleanupOldEntities() {
        const fiveDaysAgo = Date.now() - 5 * 24 * 60 * 60 * 1000;
        await this.db[this.entityName].filter(el => el.uploadedAt < fiveDaysAgo).delete();
    }

    async uploadEntity(value) {

    }
    async uploadPendingEntities() {
        try {
            const list = await this.db[this.entityName].filter(el => el.uploaded == false).toArray()
            for (let entity of list) {
                const result = await this.uploadEntity(entity)
                if(result.success) {
                    await this.db[this.entityName].update(entity.guid, {
                        uploaded: true,
                        uploadedAt: Date.now()
                    });
                }
            }
        }catch (e){
            console.log('Ошибка получения списка не загруженных сущностей', e)
        }
    }


    async saveToIndexedDB(data) {
        try {
            await this.db[this.entityName].bulkPut(data)
        } catch (error) {
            console.error('Ошибка при сохранении данных в IndexedDB:', error)
        }
    }


    async syncData() {
        try {
            const data = await this.fetchData();
            if (data) {
                await this.saveToIndexedDB(data);
                this.updateLastSyncTime();
                console.log(`✅ ${this.entityName}: синхронизация завершена, данных: ${data.length}`);
            }
        } catch (error) {
            console.error(`❌ ${this.entityName}: ошибка синхронизации`, error);
        }
    }




    async add(value) {
        if(!value.guid){
            value.guid = getGUID()
        }
        await this.db[this.entityName].add({guid: value.guid, uploaded: false,  createdAt: Date.now(),value});
        return value.guid
    }
    async replaceByGUID(value) {
        if(!value.guid){
           return null
        }

        try {
            // Ищем запись по GUID
            const existingRecord = await this.db[this.entityName].where('guid').equals(value.guid).first()
            
            if (existingRecord) {
                // Обновляем существующую запись
                await this.db[this.entityName].where('guid').equals(value.guid).modify({
                    value: value,
                    uploaded: false, // Помечаем как не загруженную, чтобы синхронизировать
                    createdAt: existingRecord.createdAt || Date.now() // Сохраняем исходное время создания
                })
                console.log(`Record with GUID ${value.guid} updated successfully`)
            } else {
                // Если записи нет, создаем новую
                await this.db[this.entityName].add({
                    guid: value.guid, 
                    uploaded: false, 
                    createdAt: Date.now(),
                    value
                })
                console.log(`Record with GUID ${value.guid} created successfully`)
            }
            
            return value.guid
        } catch (error) {
            console.error('Ошибка при обновлении/создании записи по GUID:', error)
            return null
        }
    }

    async getOneByGUID(GUID) {
        try {
            const record = await this.db[this.entityName].where('GUID').equals(GUID)
            return record
        } catch (error) {
            console.error('Ошибка при получении записи по GUID:', error)
            return null;
        }
    }
    async getOneById(id) {
        try {
            const record = await this.db[this.entityName].get(id)
            return record
        } catch (error) {
            console.error('Ошибка при получении записи по GUID:', error)
            return null;
        }
    }
    // Генерация алфавита из данных
    async generateAlphabet(letter = '') {
        try {
            const allItems = await this.db[this.entityName]
                .filter(el => el.deleted != 1 && el.title)
                .toArray()

            // Группируем по первой букве
            const letterMap = new Map()

            for (const item of allItems) {
                const title = item.title.trim()
                if (!title) continue

                const firstChar = title[0].toUpperCase()
                const twoChars = title.substring(0, 2).toUpperCase()

                if (!letterMap.has(firstChar)) {
                    letterMap.set(firstChar, new Set())
                }
                letterMap.get(firstChar).add(twoChars)
            }

            // Преобразуем в массив объектов { letter, variants }
            const alphabet = Array.from(letterMap.entries())
                .sort((a, b) => a[0].localeCompare(b[0], 'ru'))
                .map(([char, variants]) => ({
                    letter: char,
                    variants: Array.from(variants).sort((a, b) => a.localeCompare(b, 'ru'))
                }))

            return alphabet
        } catch (error) {
            console.error('Ошибка при генерации алфавита:', error)
            return []
        }
    }

    async getList(params) {
        try {

            const {search = '', epp,  page, letter = ''} = params
            const ids = params.ids != undefined ? params.ids.split(',') : null
            const show_deleted = params.show_deleted ?? true
            const equipment_group_ids = params.equipment_group_ids ?? null
            const checkSearch = el  => {
                let check = true

                if(ids && Array.isArray(ids)) {
                    if (ids.indexOf(el.id.toString()) == -1) check = false
                }
                if( search.trim().length > 0 && check) {
                    if (!el.title.toLowerCase().includes(search.trim().toLowerCase())) check = false
                }
                if(!show_deleted && check){
                    if(el.deleted == 1) check = false
                }
                // Фильтр по букве
                if (letter && letter.trim().length > 0 && check) {
                    const titleStart = el.title.substring(0, letter.length).toUpperCase()
                    if (titleStart !== letter.toUpperCase()) check = false
                }
                // Фильтр по группе
                if (equipment_group_ids && equipment_group_ids.trim().length > 0 && check) {
                    const ids = equipment_group_ids.split(",")
                    if (!ids.find(f => f == el.group_id)) check = false
                }
                return check
            }


            const total = await this.db[this.entityName]
                .filter(el => checkSearch(el)

            ).count()


            const results = await this.db[this.entityName].orderBy('title')
                .filter(el => checkSearch(el))

                .offset((page - 1) * epp)
                .limit(epp)
                .toArray()

            const iTotalPages = Math.ceil(total / epp)

            // Генерируем алфавит
            const Alfavit = await this.generateAlphabet()

            return {
                data: {
                    results,
                    total,
                    iTotalPages,
                    iTotalRecords: total,
                    iTotalDisplayRecords: results.length,
                    Alfavit
                }
            }
        } catch (error) {
            console.error('Ошибка при получении списка с поиском и пагинацией:', error)
            return {
                data: {
                    results: [],
                    total: 0,
                    iTotalPages: 0,
                    Alfavit: []
                }
            }
        }
    }
}

export { BRANDS_SYNC_TTL_MS };
export default EntitySync
